<div style="flex-direction: column; overflow: hidden; height: 100%;display: flex;">
  <div class="tabs-container" style="top: 0;position: sticky;z-index: 20;">
    <ul class="tabs">
      <li *ngIf="isAdmin" class="tab" routerLink="dashboard" routerLinkActive="active" (click)="clearSelections()">
        <mat-icon class="tab-icon">dashboard</mat-icon>
        <span>Dashboard</span>
      </li>
      <li *ngIf="isAdmin" class="tab" routerLink="manage-documents" routerLinkActive="active" (click)="clearSelections()">
        <mat-icon class="tab-icon">add_circle</mat-icon>
        <span>Create Collection</span>
      </li>
      <li *ngIf="isAdmin" class="tab" routerLink="reports" routerLinkActive="active" (click)="clearSelections()">
        <mat-icon class="tab-icon">bar_chart</mat-icon>
        <span>Reports</span>
      </li>
      <li class="tab settings-menu-item">
        <span style="display: flex; align-items: center;" (click)="toggleSettings($event)">
          <mat-icon class="tab-icon">settings</mat-icon>Settings
          <mat-icon class="dropdown-icon">expand_more</mat-icon>
        </span>
        <ul *ngIf="settingsOpen" class="app-dropdown-menu" tabindex="0" (mouseleave)="closeSettings()" (blur)="closeSettings()">
          <li *ngIf="isSuperAdmin" class="options" (click)="onSettingSelect('manage-project')"><mat-icon>work_outline</mat-icon>Manage Projects</li>
          <li *ngIf="isSuperAdmin" class="options" (click)="onSettingSelect('managecollections')"><mat-icon>settings</mat-icon>Manage Collections</li>
          <li *ngIf="isSuperAdmin" class="options" (click)="onSettingSelect('manage-document')"><mat-icon>attach_file</mat-icon>Manage Documents</li>
          <!-- <li *ngIf="isSuperAdmin" class="options" (click)="onSettingSelect('manage-report')"><mat-icon>bar_chart</mat-icon>Manage Report</li> -->
          <li class="options" (click)="onSettingSelect('manage-custom-department')"><mat-icon>apartment</mat-icon>Manage Custom Department</li>
        </ul>

      </li>

      <li class="tab" routerLink="help-support" routerLinkActive="active" (click)="clearSelections()">
        <mat-icon class="tab-icon">help_outline</mat-icon>
        <span>Help &amp; Support</span>
      </li>

    </ul>
  </div>
  <router-outlet></router-outlet>
</div>